<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DsIK1h/tc-custom/9781468306552.jpg?1738494815059" alt="This image is the cover for the book Killer, Three Days in Chicagoland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killer, Three Days in Chicagoland
      </h1>
      <p class="bookDescription body article font2">
        <b>A killer reveals his darkest secrets in this compact crime story—the thrilling conclusion to the acclaimed author’s eBook exclusive trilogy.</b><br/><br/>It’s 1956 and a young woman has been brutally murdered in Chicago. As the victim’s sister watches the killer’s execution, she believes she knows all there is to know about the grizzly crime. But new twists are revealed to the reader through the eyes of the cop who investigated the case. Now, in the third and final story in this atmospheric crime trilogy, the truth is finally revealed. <i>The Killer </i>delivers a probing portrait of what makes a murderer—with a shocking climactic twist.<br/><br/>This eBook exclusive short story includes a sample chapter of R.J. Ellory’s <i>A Dark &amp; Broken Heart</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.J. Ellory
      </h2>
      
      <p class="authorDescription body article">R.J. Ellory is the author of twelve novels, including the bestselling A Quiet Belief in Angels, which was Strand Magazine's Thriller of the Year, shortlisted for the Barry Award, and a finalist for the SIBA Award. He is also the author of City of Lies, Candlemoth, A Quiet Vendetta, A Simple Act of Violence, and the e-book original series Three Days in Chicagoland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75cd055d